export const initNaversdk = (autoSignIn, redirect_uri) => {
  var naverLogin = new naver.LoginWithNaverId(
      {
        clientId: `${process.env.VUE_APP_NAVER_CLIENT_KEY}`,
        callbackUrl: `${process.env.VUE_APP_NAVER_CALLBACK_URL}?login_save=`+autoSignIn+`&redirect_uri=`+redirect_uri,
        isPopup: false, /* 팝업을 통한 연동처리 여부 */
        loginButton: {color: "white", type: 1, height: 40} /* 로그인 버튼의 타입을 지정 */
      }
  );

  /* 설정정보를 초기화하고 연동을 준비 */
  naverLogin.init();
}
